import * as React from 'react';
import Button from '@mui/material/Button';
import RejectFormModal from '@/components/reject/RejectFormModal';
import { useMemo } from 'react';
import { useTrks } from '@/hooks/api/useTrks';
import { useAtms } from '@/hooks/api/useAtms';
import { useReportReject } from '@/hooks/api/useRejects';
import { useNotification } from '@/contexts/NotificationContext';
import { IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
interface ReportRejectActionButtonProps {
  type?: 'trk' | 'atm',
  assetId?: string
  locationIdFilter?: number
  plusButtonStyle?: boolean
}

function ReportRejectActionButton({
  type,
  assetId,
  locationIdFilter,
  plusButtonStyle
}: ReportRejectActionButtonProps) {

  
  // Add this to get today's date in YYYY-MM-DD format
  const today = useMemo(() => {
    const date = new Date();
    return date.toISOString().split('T')[0];
  }, []);

  const [reportRejectVisible, setReportRejectVisible] = React.useState(false);
  const reportRejectMutation = useReportReject();
  const { showSuccess, showError } = useNotification();
  const { data: trksData } = useTrks();
  const { data: atmsData } = useAtms();
  
  let trks = useMemo(() => {
    if (!trksData) return [];
    const trksList = Array.isArray(trksData) ? trksData : Object.values(trksData);
    return locationIdFilter ? trksList.filter((trk: any) => trk.locationId === locationIdFilter) : trksList;
  }, [trksData, locationIdFilter]);
  
  let atms = useMemo(() => {
    if (!atmsData) return [];
    const atmsList = Array.isArray(atmsData) ? atmsData : Object.values(atmsData);
    return locationIdFilter ? atmsList.filter((atm: any) => atm.locationId === locationIdFilter) : atmsList;
  }, [atmsData, locationIdFilter]);

  const submitReject = (values: any) => {
    let id = null;
    if (type) {
      values.type = type;
    }
    if (assetId) {
      id = parseInt(assetId);
    } else {
      id = values.type === 'trk' ? values.trkId : values.atmId;
    }

    reportRejectMutation.mutate({ ...values, assetId: id }, {
      onSuccess: () => {
        setReportRejectVisible(false);
        showSuccess("Reject created");
      },
      onError: (error: any) => {
        showError(error.message || "Failed to create reject");
      },
    });
  }

  return (
    <>
      {plusButtonStyle ? (
        <IconButton
        color="primary"
        onClick={() => setReportRejectVisible(true)}
      >
        <AddIcon />
      </IconButton>
      ) : (
        <Button onClick={() => setReportRejectVisible(true)} color="secondary" variant="contained" sx={{ textTransform: 'none' }}>
          Report Reject
        </Button>
      )}

      <RejectFormModal
        visible={reportRejectVisible}
        onDismiss={() => setReportRejectVisible(false)}
        onSubmit={submitReject}
        initialValues={{
          rejectDate: today
        }}
        title={`Report Reject`}
        trks={trks}
        atms={atms}
        assetId={assetId ? parseInt(assetId) : undefined}
        type={type}
      />
    </>
  );
}

export default ReportRejectActionButton;
